import { Form, Button, Segment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import autoBind from 'auto-bind';
import { Field, Form as FinalForm } from 'react-final-form';
import FileUploader from 'components/FileUploader';
import React from 'react';
import {
  uploadDiscountBlacklist,
  downloadDiscountBlacklist,
} from 'state/discountSettings/actions';
import { connect } from 'react-redux';

class DiscountSettingsBlacklistForm extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onSubmit(values) {
    const { dispatch } = this.props;
    dispatch(uploadDiscountBlacklist(values));
  }

  onDownload(event) {
    const { dispatch } = this.props;
    dispatch(downloadDiscountBlacklist());
    event.preventDefault();
  }

  render() {
    const { downloadingBlacklist, uploadingBlacklist } = this.props;
    return (
      <div>
        <FinalForm
          onSubmit={this.onSubmit}
          render={({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Segment.Group>
                <Segment>
                  <h3>Blacklist Upload</h3>
                </Segment>
                <Segment>
                  <Field
                    name="blacklist"
                    component={FileUploader}
                    accept=".csv"
                    required
                  />
                  <Button
                    content="Download blacklist.csv"
                    basic
                    loading={downloadingBlacklist}
                    onClick={this.onDownload}
                  />
                </Segment>
                <Segment>
                  <Button
                    content="Submit"
                    loading={uploadingBlacklist}
                    primary
                  />
                </Segment>
              </Segment.Group>
            </Form>
          )}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ discountSettings }) => {
  return {
    downloadingBlacklist: discountSettings.blacklist.downloading,
    uploadingBlacklist: discountSettings.blacklist.uploading,
  };
};

DiscountSettingsBlacklistForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  downloadingBlacklist: PropTypes.bool.isRequired,
  uploadingBlacklist: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(DiscountSettingsBlacklistForm);
